import {Box} from '@indoqa/style-system'
import {Landingpage} from '../../store/ar.landingpage'

interface ArTrialAccountIntroProps {
  readonly landingpage: Landingpage
}

interface ArTrialAccountBenefitsProps {
  readonly fullAccess: string
  readonly kvSystem?: boolean
}

interface CourseIntroProps {
  readonly course: string
  readonly courseGenitive: string
}

function ArTrialAccountBenefits({fullAccess, kvSystem = false}: ArTrialAccountBenefitsProps) {
  return (
    <>
      <p>Mit deinem Testzugang erhältst du:</p>
      <ul>
        <li>
          <strong>{fullAccess}</strong> auf alle Inhalte
        </li>
        <li>
          <strong>Schnelle Volltextsuche</strong> über alle Ratgeber und Fachbücher
        </li>
        <li>
          <strong>KIARA</strong>, die KI-Arbeitsrechtsassistenz
        </li>
        <li>
          Zugriff auf die <strong>VÖGB-Skripten</strong>
        </li>
        {kvSystem && (
          <li>
            Zugriff auf das <strong>KVSystem</strong>
          </li>
        )}
        <li>
          <strong>Keine automatische Verlängerung</strong> und keine Verpflichtungen
        </li>
      </ul>
    </>
  )
}

function CourseIntro({course, courseGenitive}: CourseIntroProps) {
  return (
    <>
      <p>Du bekommst hier für deinen {course} einen Zugang zum Online-Tool „Arbeitsrecht für Betriebsräte“.</p>
      <ArTrialAccountBenefits fullAccess="90 Tage kostenlosen Vollzugriff" />
      <p>Bitte fülle dieses Formular vor dem Beginn deines {courseGenitive} vollständig aus.</p>
      <p>
        Du erhältst vollen Zugriff auf das Online-Tool „Arbeitsrecht für Betriebsräte“ und den integrierten KI-Chatbot
        vom ÖGB-Verlag und kannst während des Kurses auf Inhalte aus dem Arbeitsrecht zugreifen.
      </p>
    </>
  )
}

function GewerkschaftsschuleIntro() {
  return (
    <>
      <p>Hier bekommst du wichtige Zugänge für die Gewerkschaftsschule.</p>
      <p>
        Du erhältst vollen Zugriff auf das Online-Tool „Arbeitsrecht für Betriebsräte“ und das KVSystem. Damit kannst du
        während des ersten und zweiten Semesters auf Inhalte aus dem Arbeitsrecht zugreifen und im System aller
        Kollektivverträge recherchieren.
      </p>
      <ArTrialAccountBenefits fullAccess="Kostenlosen Vollzugriff" kvSystem />
      <p>Bitte fülle dieses Formular vor dem Beginn deiner Gewerkschaftsschule vollständig aus.</p>
    </>
  )
}

function DefaultIntro() {
  return (
    <>
      <p>
        Erstelle jetzt deinen kostenlosen Testzugang und lerne „Arbeitsrecht für Betriebsräte" unverbindlich kennen.
      </p>
      <ArTrialAccountBenefits fullAccess="30 Tage kostenlosen Vollzugriff" />
      <h2>Starte jetzt kostenlos</h2>
      <p>
        Überzeuge dich selbst von den umfangreichen Fachinhalten und dem integrierten KI-Chatbot für Betriebsrät:innen –
        30 Tage lang kostenlos und unverbindlich testen.
      </p>
    </>
  )
}

function RabattaktionProgeIntro() {
  return (
    <>
      <p>
        Erstelle jetzt deinen kostenlosen Testzugang und lerne „Arbeitsrecht für Betriebsräte" unverbindlich kennen.
      </p>
      <ArTrialAccountBenefits fullAccess="30 Tage kostenlosen Vollzugriff" />
      <Box pt={4}>
        <p>
          <strong>Exklusiv</strong> bis 30.11.2026 erhältst du mit dem <strong>Rabattcode deiner PROGE</strong> beim
          Kauf von „Arbeitsrecht für Betriebsräte“ <strong>10% Rabatt</strong> im ersten Jahr.
        </p>
      </Box>
      <h2>Starte jetzt kostenlos!</h2>
      <p>
        Überzeuge dich selbst von den umfangreichen Fachinhalten und dem integrierten KI-Chatbot für Betriebsrät:innen –
        30 Tage lang kostenlos und unverbindlich testen.
      </p>
    </>
  )
}

function renderIntro(landingpage: Landingpage) {
  switch (landingpage) {
    case 'grundkurs-proge':
      return <CourseIntro course="BR-Grundkurs der PRO-GE" courseGenitive="Grundkurses" />
    case 'rabattaktion-proge-2026':
      return <RabattaktionProgeIntro />
    case 'basiskurs-gpa':
      return <CourseIntro course="BR-Basiskurs der GPA" courseGenitive="Basiskurses" />
    case 'gewerkschaftsschule-oberoesterreich':
      return <GewerkschaftsschuleIntro />
    case 'arfbr-digital':
      return <DefaultIntro />
  }
}

export function ArTrialAccountIntro({landingpage}: ArTrialAccountIntroProps) {
  return <Box pb={4}>{renderIntro(landingpage)}</Box>
}
